import gql from 'graphql-tag'

export const Q_GET_NOTICES = gql`
  query notices($where: NoticeWhereInput) {
    notices(where: $where) {
      id
      memberId
      noticeTypeId
      offenseId
      offenseTypeId
      issuedDate
      expirationDate
      description
      body
      approvedBy
      approvedDate
      noticeState
      member {
        fullName
      }
      noticeType {
        name
      }
      offenseType {
        name
      }
    }
  }
`

export const M_UPDATE_NOTICE = gql`
  mutation updateNotice(
    $id: Int!
    $body: String
  ) {
    updateNotice(
      id: $id
      body: $body
    ) {
      id
      body
    }
  }
` 